import { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { IonModal, IonIcon, IonText, IonImg, IonButton, IonGrid, IonRow, IonCol } from '@ionic/react';
import { star, starOutline, cameraOutline, close, bedOutline } from 'ionicons/icons';
import { Constants } from '../../../defines/Constants';
import { MealPlans } from '../../../defines/Functions';
import CurrencyFormat from 'react-currency-format';
import HotelRoomTerm from './HotelRoomTerm';
import moment from 'jalali-moment';
import Map from '../../Map';
import Fancybox from '../../Fancybox';
import axios from "axios";
import Loading from '../../Loading';
import './HotelDetails.css';
import mapImg from '../../../assets/images/map.svg';

import { App as CapacitorApp } from '@capacitor/app';
import { Fancybox as NativeFancybox } from '@fancyapps/ui';


interface Props {
    hotelCode: any,
    data: any,
    item: any,
    type?: string,
    activeFlight?: any
    hotelData?: any,
    flightData?: any,
    flightHotelDefines?: any
}
const HotelDetails = (props: Props) => {
    const location = useLocation();
    const currentPage = location.pathname;
    const hotelsRooms = Constants.api.hotelsRooms;
    const [loading, setLoading] = useState(false);
    const [state, setState] = useState({
        showHotelDetailsModal: false,
        errorMessage: '',
        hotelStay: [] as any,
        roomStay: [] as any
    });
    const [hotelData, setHotelData] = useState([]) as any;
    const hotelDetailsApi = Constants.api.hotelsInfo;
    const hotelCode = props.hotelCode;
    const getHotelRooms = async () => {
        let xmlData = '<OTA_HotelAvailRQ CorrelationID="' + props.data.correlationId + '">';
        xmlData += '<AvailRequestSegments>';
        xmlData += '<AvailRequestSegment>';
        xmlData += '<HotelSearchCriteria>';
        xmlData += '<Criterion>';
        xmlData += '<HotelRef HotelCode="' + props.data.hotelCode + '"/>';
        xmlData += '<StayDateRange Start="' + props.data.startDate + '" End="' + props.data.endDate + '" />';
        xmlData += '<Address>';
        xmlData += '<CityName>' + props.data.cityName + '</CityName>';
        xmlData += '<CountryName Code="' + props.data.countryName + '"></CountryName>';
        xmlData += '</Address>';
        xmlData += '<RateRange MinRate="1" MaxRate="5" />';
        xmlData += '<Profiles>';
        xmlData += '<ProfileInfo>';
        xmlData += '<Profile>';
        xmlData += '<Customer CurrencyCode="IRR">';
        xmlData += '<CitizenCountryName Code="' + props.data.countryName + '"/>';
        xmlData += '</Customer>';
        xmlData += '</Profile>';
        xmlData += '</ProfileInfo>';
        xmlData += '</Profiles>';
        xmlData += '<RoomStayCandidates>';
        props.data.rooms.forEach((item: any) => {
            xmlData += '<RoomStayCandidate>';
            xmlData += '<GuestCounts>';
            xmlData += '<GuestCount AgeQualifyingCode="Adult" Count="' + item.adults + '" />';
            if (item.childsAges.length !== 0) {
                item.childsAges.forEach((itemChild: any) => {
                    xmlData += '<GuestCount AgeQualifyingCode="Child" Age="' + itemChild + '" Count="1" />';
                });
            }
            xmlData += '</GuestCounts>';
            xmlData += '</RoomStayCandidate>';
        });
        xmlData += '</RoomStayCandidates>';
        xmlData += '</Criterion>';
        xmlData += '</HotelSearchCriteria>';
        xmlData += '</AvailRequestSegment>';
        xmlData += '</AvailRequestSegments>';
        xmlData += '</OTA_HotelAvailRQ>';
        try {
            const results = await axios.post(hotelsRooms, xmlData, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
            if (results.data.status === 'error') {
                setState({ ...state, errorMessage: 'خطا در برقراری ارتباط با وب سرویس' });
                setLoading(false);
            } else {
                if (results.data.items.hasOwnProperty('errors')) {
                    setState({ ...state, errorMessage: 'نتیجه ای یافت نشد', roomStay: [] });
                } else {
                    let myData = {} as any;
                    results.data.items.roomStays.roomStay.forEach((rms: any) => {
                        if (!myData[rms.roomStayGroupID]) {
                            myData[rms.roomStayGroupID] = [];
                        }
                        if (
                            rms.tpaextensions !== undefined &&
                            rms.tpaextensions.any !== undefined &&
                            rms.tpaextensions.any[0].length &&
                            rms.tpaextensions.any[0].freeTransfer !== undefined &&
                            rms.tpaextensions.any[0].freeTransfer === 'true'
                        ) {
                            rms.freeTransfer = 'دارد';
                        } else {
                            rms.freeTransfer = 'ندارد';
                        }
                        myData[rms.roomStayGroupID].push({ rms });
                    });
                    setState({ ...state, errorMessage: '', hotelStay: results.data.items.hotelStays.hotelStay, roomStay: myData });
                }
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setState({ ...state, errorMessage: 'خطا در برقراری ارتباط با وب سرویس', roomStay: [] });
            setLoading(false);
        }
    }
    useEffect(() => {
        if (state.showHotelDetailsModal) {
            const fetchHotelDetails = async () => {
                let xmlData = '<OTA_HotelDescriptiveInfoRQ>';
                xmlData += '<HotelDescriptiveInfos>';
                xmlData += '<HotelDescriptiveInfo HotelCode="' + hotelCode + '"/>';
                xmlData += '</HotelDescriptiveInfos>';
                xmlData += '</OTA_HotelDescriptiveInfoRQ>';
                try {
                    setLoading(true);
                    const results = await axios.post(hotelDetailsApi, xmlData, {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                        }
                    });
                    if (results.data.items.hotelDescriptiveContents.hotelDescriptiveContent.length !== 0) {
                        setState({ ...state, errorMessage: '' });
                        setHotelData(results.data.items.hotelDescriptiveContents.hotelDescriptiveContent);
                        getHotelRooms();
                    } else {
                        setState({ ...state, errorMessage: 'نتیجه ای یافت نشد!' });
                        setHotelData([]);
                        setLoading(false);
                    }
                } catch (error) {
                    console.log(error);
                    setState({ ...state, errorMessage: 'خطا در برقراری ارتباط با وب سرویس.' });
                    setHotelData([]);
                    setLoading(false);
                }
            }
            fetchHotelDetails();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hotelCode, state.showHotelDetailsModal]);
    const onCloseModal = () => {
        setState({ ...state, showHotelDetailsModal: false });
    }
    // =====================================================================================================
    //                                          Hotel Rooms
    // =====================================================================================================
    const history = useHistory();
    let departureDate = '';
    let arrivalDate = '';
    if (props.type !== 'flightHotel') {
        departureDate = props.item.hotelDefines.all[0].dates.dates[0];
        arrivalDate = props.item.hotelDefines.all[0].dates.dates[1];
    } else {
        departureDate = props.item.flightHotelDefines.all.dates.departure;
        arrivalDate = props.item.flightHotelDefines.all.dates.arrival;
    }
    const reserveStartDate = moment(departureDate, 'YYYY-MM-DD');
    const reserveEndDate = moment(arrivalDate, 'YYYY-MM-DD');
    const reserveNightsCount = reserveEndDate.diff(reserveStartDate, 'days');
    const onReserveClick = (hotelRoom: any) => {
        setState({ ...state, showHotelDetailsModal: false });
        let propsItem = {
            id: props.item.id,
            data: props.item.data,
            expireTime: props.item.expireTime,
            hotelDefines: props.item.hotelDefines,
            roomStays: props.item.roomStays
        }
        if (props.type !== 'flightHotel') {
            history.push({
                pathname: '/hotel/reservation',
                state: { data: props.data, item: propsItem, hotelRoom: hotelRoom }
            });
        } else {
            history.push({
                pathname: '/flightHotel/reservation',
                state: { data: props.data, item: propsItem, hotelRoom: hotelRoom, hotelData: props.hotelData, flightData: props.flightData, flightHotelDefines: props.flightHotelDefines, activeFlight: props.activeFlight }
            });
        }
    }
    CapacitorApp.addListener("backButton", (e) => {
        const htmlEl = document.querySelector('html') as any;
        if (htmlEl) {
            if (htmlEl.classList.contains('with-fancybox')) {
                NativeFancybox.close();
            }
        }
    });
    return (
        <>
            <IonModal isOpen={state.showHotelDetailsModal} onDidDismiss={onCloseModal} mode="ios" cssClass="hotel-details-modal">
                <div className="hotel-details-modal-content">
                    <h3 className="hotel-details-modal-title">
                        جزئیات هتل
                        <IonIcon icon={close} onClick={onCloseModal} />
                    </h3>
                    {hotelData.length !== 0 && !loading ?
                        <div className="ion-padding hotel-details-content">
                            <div className="box-1">
                                <h5>
                                    <span>
                                        {[...Array(5)].map((_, indexRate) =>
                                            indexRate + 1 <= Math.floor(parseInt(hotelData[0].affiliationInfo.awards.award[0].rating)) ?
                                                <IonIcon icon={star} color="warning" key={'indexRate' + indexRate} />
                                                :
                                                <IonIcon icon={starOutline} color="warning" key={'indexRate' + indexRate} />
                                        )}
                                    </span>
                                    {hotelData[0].hotelName}
                                </h5>
                                <IonText>
                                    {hotelData[0].contactInfos.contactInfo[0].addresses.address[0].remark}
                                </IonText>
                                <div className="view-on-map-label">
                                    <a href={"https://www.google.com/maps/search/?api=1&query=" + hotelData[0].hotelInfo.position.latitude + ',' + hotelData[0].hotelInfo.position.longitude} target="_blank" rel="noreferrer">
                                        موقعیت بر روی نقشه
                                        <IonIcon icon={mapImg} />
                                    </a>
                                </div>
                            </div>
                            <div className="box-2">
                                <Map location={[hotelData[0].hotelInfo.position.latitude, hotelData[0].hotelInfo.position.longitude]} />
                            </div>
                            <div className="box-3">
                                <Fancybox options={{ infinite: false }}>
                                    {hotelData[0].multimediaDescriptions.multimediaDescription[0].imageItems.imageItem.map((imageItem: any, imageIndex: number) =>
                                        <div
                                            className={imageIndex === 0 ? "col-1" : imageIndex === 1 ? "col-2" : imageIndex === 2 ? "col-3" : imageIndex === 3 ? "col-4" : undefined}
                                            data-fancybox="gallery"
                                            data-src={imageItem.id}
                                            key={'index' + imageIndex}
                                        >
                                            {(imageIndex >= 0 && imageIndex <= 3) &&
                                                <>
                                                    <IonImg src={imageItem.id} />
                                                    {imageIndex === 3 &&
                                                        <span>
                                                            <IonIcon icon={cameraOutline} />
                                                        </span>
                                                    }
                                                </>
                                            }
                                        </div>
                                    )}
                                </Fancybox>
                            </div>
                            {hotelData[0].multimediaDescriptions.multimediaDescription[0].textItems.textItem.length ?
                                <div className="box-4">
                                    {hotelData[0].multimediaDescriptions.multimediaDescription[0].textItems.textItem.map((textItem: any, textIndex: number) =>
                                        textItem.title !== 'Payment' &&
                                        <div key={'index' + textIndex}>
                                            <h5>{textItem.title}</h5>
                                            <IonText>
                                                {textItem.description[0].value}
                                            </IonText>
                                        </div>
                                    )}
                                </div>
                                :
                                null
                            }
                            {currentPage !== '/flightHotel/reservation' &&
                                <>
                                    <h6>
                                        از تاریخ
                                        <span> {moment(reserveStartDate).locale('fa').format('dddd D MMMM YYYY')} </span>
                                        تا تاریخ
                                        <span> {moment(reserveEndDate).locale('fa').format('dddd D MMMM YYYY')} </span>
                                        به مدت
                                        <span> {reserveNightsCount} شب </span>
                                    </h6>
                                    {Object.values(state.roomStay).map((hotelRoom: any, index: number) =>
                                        <div className="box-5" key={'index' + index}>
                                            <IonGrid>
                                                <IonRow className="room-item" key={"index" + index}>
                                                    <IonCol size="4" className="">
                                                        <div>
                                                            {hotelRoom.map((hrms: any, hrmsIndex: number) =>
                                                                <div key={"hrms" + hrmsIndex}>
                                                                    {hrmsIndex === 0 &&
                                                                        <b>اتاق</b>
                                                                    }
                                                                    <span>
                                                                        {hrms.rms.roomTypes.roomType[0].tpaextensions !== undefined ?
                                                                            hrms.rms.roomTypes.roomType[0].tpaextensions.any[0].persianRoomType
                                                                            :
                                                                            hrms.rms.roomTypes.roomType[0].roomType
                                                                        }
                                                                    </span>
                                                                </div>

                                                            )}
                                                        </div>
                                                    </IonCol>
                                                    <IonCol size="4">
                                                        {hotelRoom.map((hrms: any, hrmsIndex: number) =>
                                                            <div key={"hrms" + hrmsIndex}>
                                                                {hrmsIndex === 0 &&
                                                                    <b>خدمات</b>
                                                                }
                                                                <span>{MealPlans(hrms.rms.roomRates.roomRate[0].ratePlanID)}</span>
                                                            </div>
                                                        )}
                                                    </IonCol>
                                                    <IonCol size="4">
                                                        {hotelRoom.map((hrms: any, hrmsIndex: number) =>
                                                            <div key={"hrms" + hrmsIndex}>
                                                                {hrmsIndex === 0 &&
                                                                    <b>ترانسفر رایگان</b>
                                                                }
                                                                <span>{hrms.rms.freeTransfer}</span>
                                                            </div>
                                                        )}
                                                    </IonCol>
                                                    {state.hotelStay[0].basicPropertyInfo.hotelAmenity.length !== 0 &&
                                                        <IonCol size="12" className="hotel-amenity">
                                                            <b>امکانات هتل : </b>
                                                            {state.hotelStay[0].basicPropertyInfo.hotelAmenity.map((amenity: any, amenityIndex: number) =>
                                                                <span key={"index" + amenityIndex}>
                                                                    <IonIcon icon={star} />
                                                                    {amenity.Code}
                                                                </span>
                                                            )}
                                                        </IonCol>
                                                    }
                                                    <IonCol size="12" className="room-price-col">
                                                        <div className="room-price">
                                                            {hotelRoom.map((_: any, hrmsIndex: number) =>
                                                                hrmsIndex === 0 &&
                                                                <span key={"index" + hrmsIndex}>
                                                                    مجموع {hotelRoom.length} اتاق :
                                                                </span>
                                                            )}
                                                            {hotelRoom[0].rms.basicPropertyInfo.hasOwnProperty('vendorMessages') &&
                                                                hotelRoom[0].rms.basicPropertyInfo.vendorMessages.vendorMessage.map((vm: any, vmIndex: number) =>
                                                                    vm.infoType === 'Discount' && vm.title !== 0 &&
                                                                    <span className="discount">
                                                                        <CurrencyFormat value={vm.title} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                                                                    </span>
                                                                )
                                                            }
                                                            <b>
                                                                {props.type !== 'flightHotel' ?
                                                                    <CurrencyFormat value={hotelRoom[0].rms.total.amountAfterTax} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                                                                    :
                                                                    <CurrencyFormat value={hotelRoom[0].rms.total.amountAfterTax + props.activeFlight.airItineraryPricingInfo.itinTotalFare[0].equivFare[0].amount} displayType={'text'} thousandSeparator={true} suffix={' ریال'} />
                                                                }
                                                            </b>
                                                        </div>
                                                    </IonCol>
                                                    <IonCol size="6">
                                                        <HotelRoomTerm data={hotelRoom[0].rms.reference} dataDefines={props.type !== 'flightHotel' ? props.item.hotelDefines : props.item.flightHotelDefines} />
                                                    </IonCol>
                                                    <IonCol size="6" className="hotel-room-reserve-btn">
                                                        <IonButton color="warning" expand="block" onClick={() => onReserveClick(hotelRoom)}>
                                                            رزرو اتاق
                                                            <IonIcon icon={bedOutline} />
                                                        </IonButton>
                                                    </IonCol>
                                                </IonRow>
                                            </IonGrid>
                                        </div>
                                    )}
                                </>
                            }
                        </div>
                        :
                        <Loading />
                    }
                </div>
                <div className="hotel-details-modal-footer-btns">
                    <IonButton color="warning" expand="block" onClick={onCloseModal} className="hotel-details-modal-close-btn">
                        بستن
                    </IonButton>
                </div>
            </IonModal>
            {props.type !== 'flightHotel' ?
                <IonText className="hotel-details-label" onClick={() => setState({ ...state, showHotelDetailsModal: true })}>
                    جزئیات هتل
                </IonText>
                :
                <IonButton color="warning" expand="block" fill="outline" className="flight-hotel-details-btn" onClick={() => setState({ ...state, showHotelDetailsModal: true })}>
                    جزئیات هتل
                </IonButton>
            }
        </>
    );
};

export default HotelDetails;
